import React, { Component } from "react";

class SponsorValue extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const price = this.props.price;
    return (
      <div className="child-detail__value child-detail__item">
        <p className="value__heading beta">What does my ${price} a month do?</p>
        <p className="value__content">
          We pool monthly sponsorship donations for maximum impact in each community. You'll help your child and other vulnerable children in the community with life-changing things like: <strong>clean water, nutrition, healthcare, education, jobs for parents, protection, and sharing God's love.</strong>
        </p>
      </div>
    );
  }
}

export default SponsorValue;